export default __webpack_public_path__ + "static/black-black-desserto-da290cbcded35e69d27033eea2d933ef.png";